import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getProductiveCycleStageList,
	addNewProductiveCycleStage,
	updateProductiveCycleStage,
	deleteProductiveCycleStage,
	getProductiveCycleStage,
} from '../productiveCycleStage/thunk';

export const initialState = {
	itemProductiveCycleStageList: [],
	itemProductiveCycleStageDetail: null,
	isProductiveCycleStageLoading: false,
	isProductiveCycleStageSuccess: false,

	productiveCycleStageList: [],
	productiveCycleStageListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ProductiveCycleStageSlice = createSlice({
	name: 'ProductiveCycleStage',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getProductiveCycleStage.fulfilled, (state, action) => {
			state.isProductiveCycleStageLoading = false;
			state.isProductiveCycleStageSuccess = true;
			state.itemProductiveCycleStageDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getProductiveCycleStage.pending, state => {
			state.isProductiveCycleStageLoading = true;
			state.isProductiveCycleStageSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getProductiveCycleStage.rejected, (state, action) => {
			state.isProductiveCycleStageLoading = false;
			state.isProductiveCycleStageSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getProductiveCycleStageList.pending, state => {
			state.isProductiveCycleStageSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getProductiveCycleStageList.fulfilled, (state, action) => {
			state.itemProductiveCycleStageList = action.payload;
			state.productiveCycleStageList = action.payload;
			state.isLoadingList = false;
			state.isProductiveCycleStageSuccess = true;

			let productiveCycleStageListSelect = [];
			action.payload.map(item =>
				productiveCycleStageListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.productiveCycleStageListSelect = productiveCycleStageListSelect;
		});
		builder.addCase(getProductiveCycleStageList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isProductiveCycleStageSuccess = true;
		});
		builder.addCase(addNewProductiveCycleStage.fulfilled, (state, action) => {
			state.itemProductiveCycleStageList.push(action.payload);
			state.productiveCycleStageList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewProductiveCycleStage.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewProductiveCycleStage.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateProductiveCycleStage.fulfilled, (state, action) => {
			state.itemProductiveCycleStageList = state.itemProductiveCycleStageList.map(productiveCycleStage =>
				productiveCycleStage.productiveCycleStagename === action.payload.old_productiveCycleStage
					? { ...productiveCycleStage, ...action.payload.updated_productiveCycleStage }
					: productiveCycleStage
			);
			state.productiveCycleStageList = state.productiveCycleStageList.map(productiveCycleStage =>
				productiveCycleStage._id.toString() === action.payload._id.toString()
					? { ...productiveCycleStage, ...action.payload }
					: productiveCycleStage
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateProductiveCycleStage.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateProductiveCycleStage.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteProductiveCycleStage.fulfilled, (state, action) => {
			state.itemProductiveCycleStageList = current(state.itemProductiveCycleStageList).filter(
				item => item._id !== action.payload._id
			);
			state.productiveCycleStageList = current(state.productiveCycleStageList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteProductiveCycleStage.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteProductiveCycleStage.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ProductiveCycleStageSlice.actions;

export default ProductiveCycleStageSlice.reducer;
